module.exports = __webpack_public_path__ + "static/media/XL.39b85943.jpg";